(() => {
  if (window.z12PlayRequestedMedia) return;
  let sequence = 0;
  window.z12ClaimMedia = (owner, stop) => {
    const previous = window.z12MediaOwner;
    if (previous?.owner === owner) return;
    window.z12MediaOwner = null;
    previous?.stop?.();
    window.z12MediaOwner = { owner, stop };
  };
  window.z12ReleaseMedia = owner => { if (window.z12MediaOwner?.owner === owner) window.z12MediaOwner = null; };
  const youtubeAPI = () => {
    if (window.YT?.Player) return Promise.resolve(window.YT);
    if (window.z12HoverYouTubeAPI) return window.z12HoverYouTubeAPI;
    window.z12HoverYouTubeAPI = new Promise((resolve, reject) => {
      const previous = window.onYouTubeIframeAPIReady;
      const timer = setTimeout(() => reject(new Error('YouTube API timeout')), 15000);
      window.onYouTubeIframeAPIReady = () => {
        try { previous?.(); } finally { clearTimeout(timer); resolve(window.YT); }
      };
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api'; script.async = true;
        script.addEventListener('error', () => { clearTimeout(timer); reject(new Error('YouTube API unavailable')); }, { once: true });
        document.head.append(script);
      }
    });
    return window.z12HoverYouTubeAPI;
  };
  window.z12PlayRequestedMedia = (media, valid = () => media.isConnected && !document.hidden, onStop) => {
    media.z12PlaybackCleanup?.();
    window.z12ClaimMedia(media, onStop || (() => { media.z12PlaybackCleanup?.(); if (media.tagName === 'VIDEO') media.pause(); else media.removeAttribute('src'); }));
    let cancelled = false, player = null;
    const wanted = () => !cancelled && media.isConnected && valid();
    media.z12PlaybackCleanup = () => {
      cancelled = true;
      window.z12ReleaseMedia(media);
      const parent = media.parentNode, next = media.nextSibling;
      try { player?.destroy?.(); } catch (_) {}
      if (parent?.isConnected && !media.isConnected) parent.insertBefore(media, next?.parentNode === parent ? next : null);
      player = null;
    };
    if (media.tagName === 'VIDEO') {
      media.playsInline = true; media.controls = true;
      const failed = (error) => {
        if (!wanted() || error?.name !== 'NotAllowedError') return;
        media.muted = true;
        try { Promise.resolve(media.play()).catch(() => { media.controls = true; }); } catch (_) {}
      };
      try { Promise.resolve(media.play()).catch(failed); } catch (_) { failed(); }
      return;
    }
    if (media.tagName !== 'IFRAME') return;
    const source = media.getAttribute('src') || media.dataset.videoSrc;
    if (!source) return;
    const url = new URL(source, location.href);
    url.searchParams.set('autoplay', '1'); url.searchParams.set('playsinline', '1');
    media.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    const youtube = /(^|\.)youtube(-nocookie)?\.com$/.test(url.hostname);
    if (youtube) {
      url.searchParams.set('mute', '1'); url.searchParams.set('controls', '1');
      url.searchParams.set('enablejsapi', '1'); url.searchParams.set('origin', location.origin);
    } else if (url.hostname === 'player.vimeo.com') url.searchParams.set('muted', '1');
    media.src = url.toString();
    if (!youtube) return;
    if (!media.id) media.id = 'Z12RequestedVideo-' + (++sequence);
    youtubeAPI().then(YT => {
      if (!wanted()) return;
      player = new YT.Player(media, { events: {
        onReady: event => { if (wanted()) { event.target.mute(); event.target.playVideo(); } },
        onAutoplayBlocked: () => { media.dataset.z12PlayBlocked = 'true'; },
        onError: () => { media.dataset.z12PlayBlocked = 'true'; }
      }});
    }).catch(() => { if (wanted()) media.dataset.z12PlayBlocked = 'true'; });
  };
})();
